export default __webpack_public_path__ + "static/media/granolin.35178001.png";